import React from 'react'
import { observer } from 'mobx-react'
import useSelection from '../hooks/use-selection'
import useModelKey from '../hooks/use-model-key'

function DeselectOnClick (props) {
  const selection = useSelection()
  const modelKey = useModelKey()

  const handleClick = () => {
    if (!modelKey) {
      return
    }

    selection.delete(modelKey)
  }

  return (
    <div onClick={handleClick}>
      {props.children}
    </div>
  )
}

export default observer(DeselectOnClick)
